import { client } from 'shared';

export async function hire(user_id: number, business_location_id: number, hire: boolean, hireDate?: Date | null) {
    return client('api/staff/hire/', {
        method: 'PATCH',
        body: {
            user_id,
            business_location_id,
            hire,
            hire_date: hireDate,
        },
    });
}

export interface HireLocation {
    id: number;
    name: string;
}

export async function getHireLocations(provider_user_id: number): Promise<{ locations: HireLocation[] }> {
    return client(`api/staff/hire-locations/?provider_user_id=${provider_user_id}`);
}

export async function markHiredByCenter(
    provider_user_id: number,
    business_location_id?: number,
): Promise<{ hire_date: string; business_location: HireLocation | null }> {
    return client('api/staff/mark-hired/', {
        method: 'PATCH',
        body: { provider_user_id, business_location_id },
    });
}
